import Icon from 'components/atoms/icon/Icon';
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen';
import NoDataBoundary from 'components/atoms/no-data-boundary/NoDataBoundary';
import { customStyles } from 'lib/helpers/configs/customStyles';
import { IconType } from 'lib/helpers/constants/iconTypes';
import { useWidgetData } from 'lib/hooks/queries/Dashboard/useWidgetData';
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/creatable';
import Creatable from "react-select/creatable";
import { customStylesLightBorder } from 'lib/helpers/configs/customStyles';


interface Props {
    name: string;
    api: string;
    type: string;
}

const LeaderBoardWidget: FC<Props> = ({ name, api, type }) => {

    const { t } = useTranslation();


    const [Filters, setFilters] = useState({
        type_of_statistic: 'Total Customers',
        filter_on: 'Today',
    })
    

    const { data, isLoading } = useWidgetData({ endpoint: api, params: { filter_on: Filters.filter_on, type_of_statistic:Filters?.type_of_statistic?.split(' ').join('')  }, type: name })

    if (isLoading) return <LoadingScreen />

    return (
        <div className='w-full h-full bg-white border border-[#F2F4F7] rounded-2xl p-5'>
            <div className='pb-5 flex items-center gap-4 justify-between'>
                <div className='text-primaryTextColor font-inter-bold xl:text-lg 2xl:text-xl'>
                    {t(name)}
                </div>
                <div>
                    <CreatableSelect<any, false>
                        options={[
                            { value: "Today", label: t("Today") },
                            { value: "This week", label: t("This week") },
                            { value: "This month", label: t("This month") },
                        ]}
                        value={{
                            value: Filters.filter_on,
                            label: t(Filters.filter_on)
                        }}
                        className="cursor-pointer font-inter-regular react-select-container 3xl:min-w-[150px]"
                        classNamePrefix="react-select"
                        onChange={(newValue: any, actionMeta: any) => {
                            if (
                                actionMeta.action === "select-option" &&
                                newValue?.value
                            ) {
                                setFilters(prev => ({
                                    ...prev,
                                    filter_on: newValue.value,
                                }))
                            }
                        }}
                        styles={customStyles}
                        isValidNewOption={() => false}
                        menuPosition={"fixed"}
                        menuPortalTarget={document.body}
                    />
                </div>
            </div>
            <div className='pb-10'>
                <Creatable<any, false>
                    placeholder={t('')}
                    options={[
                        {
                            label: t('Total Customers'),
                            value: 'Total Customers'
                        },
                        {
                            label: t('Customers From Leads'),
                            value: 'Customers From Leads'
                        },
                        {
                            label: t('Customers From Appointment'),
                            value: 'Customers From Appointment'
                        },
                        {
                            label: t('Total Provision'),
                            value: 'Total Provision'
                        },
                        {
                            label: t('Total Won Appointments'),
                            value: 'Total Won Appointments'
                        },
                        {
                            label: t('Won Appointments From Leads'),
                            value: 'Won Appointments From Leads'
                        }
                    ]}
                    value={{ value: Filters.type_of_statistic, label: t(Filters.type_of_statistic) }}
                    className="cursor-pointer font-inter-regular react-select-container w-full min-w-[150px]"
                    classNamePrefix="react-select"
                    onChange={(newValue: any) => {
                        setFilters((prevFilters) => ({
                            ...prevFilters,
                            type_of_statistic: newValue.value,
                        }));
                    }}
                    styles={customStylesLightBorder}
                    isValidNewOption={() => false}
                    menuPosition={"fixed"}
                    menuPortalTarget={document.body}
                />
            </div>
            <div className='overflow-hidden'>
                <div className='border border-[#F2F4F7] rounded-[8px]'>
                    <div className='bg-[#F2F4F7] rounded-t-[8px] py-2 px-4 flex gap-4 text-primaryTextColor font-inter-medium'>
                        <div className='basis-1/4'>

                            {t('Rank')}
                        </div>
                        <div className='basis-2/4'>
                            {t('Agent Name')}
                        </div>
                        <div className='basis-1/4 text-center'>
                            {t(type)}
                        </div>
                    </div>
                    <NoDataBoundary
                        condition={data && data?.length > 0}
                        fallback={
                            <p className="text-[#7D8592] font-inter-regular mx-auto my-20 flex justify-center">
                                {t("There is no")} data {t("in this section.")}
                            </p>
                        }
                    >

                        {(data as any)?.length > 0 && data?.map((item: any, index: number) => (
                            <div key={index} className='border-t border-t-[#F2F4F7] flex gap-4 h-[75px] items-center px-4 text-primaryTextColor font-inter-semibold'>
                                <div className={`basis-1/4 ${index > 3 ? 'ps-3' : ''}`}>
                                    {index < 3
                                        ? {
                                            0: <Icon iconType={IconType.LEADERBOARD_FIRST} />,
                                            1: <Icon iconType={IconType.LEADERBOARD_SECOND} />,
                                            2: <Icon iconType={IconType.LEADERBOARD_THIRD} />,

                                        }[index]
                                        : index + 1
                                    }

                                </div>
                                <div className='basis-2/4'>
                                    {item.from_user}
                                </div>
                                <div className='basis-1/4 text-center'>
                                    {item.total}
                                </div>
                            </div>
                        ))}
                    </NoDataBoundary>
                </div>
            </div>
        </div>

    )
}

export default LeaderBoardWidget